<div class="use-cases-modal-container flex flex-col gap-[16px]">
  <div class="full-width use-case-type-container flex flex-col gap-[16px] flex-1">
    <div class="flex flex-row justify-between items-start">
      <h2>
        {{ 'DIAGNOSTICS.USE_CASES.SELECT_USE_CASE_TYPE.TITLE' | translate }}
      </h2>
      <mat-icon (click)="dialogRef.close()">close</mat-icon>
    </div>

    <div class="flex flex-col gap-[8px]">
      <div
        *ngIf="installationDetailsStore.isServiceLayerVisible$ | async"
        class="use-case-panel flex flex-row justify-between items-center"
        [class.selected]="selectedUseCaseType === useCaseTypesEnum.ServiceLayer"
        [class.unselected]="
          selectedUseCaseType && selectedUseCaseType !== useCaseTypesEnum.ServiceLayer
        "
        (click)="onSelectUseCaseType(useCaseTypesEnum.ServiceLayer)"
        gtm="onSelectUseCaseType"
        gtmAction="Diagnostics Overlay"
        gtmCategory="Select use case type"
      >
        <div>{{ 'DIAGNOSTICS.EXTENDED_PARAMETERS_TAB.SERVICE_LAYER' | translate }}</div>
        <mat-icon *ngIf="!selectedUseCaseType; else showCloseBtn">add</mat-icon>
        <ng-template #showCloseBtn>
          <button
            mat-icon-button
            (click)="onUnselectUseCaseType($event)"
            gtm="onUnselectUseCaseType"
            gtmAction="Diagnostics Overlay"
            gtmCategory="Unselect use case type"
          >
            <mat-icon>close</mat-icon>
          </button>
        </ng-template>
      </div>

      <ng-container *ngFor="let useCase of remoteDiagnosticsUseCasesStore.useCases$ | async">
        <div
          *ngIf="
            useCase.usecasetype === useCaseTypesEnum.ConfigurationOverview ||
            useCase.usecasetype === useCaseTypesEnum.DiagnosisOverview ||
            useCase.usecasetype === useCaseTypesEnum.InspectionDashboard
          "
          class="use-case-panel flex flex-row justify-between items-center"
          [class.selected]="selectedUseCaseType && selectedUseCaseType === useCase.usecasetype"
          [class.unselected]="selectedUseCaseType && selectedUseCaseType !== useCase.usecasetype"
          (click)="onSelectUseCaseType(useCase.usecasetype)"
          gtm="onSelectUseCaseType"
          gtmAction="Diagnostics Overlay"
          gtmCategory="Select use case type"
        >
          <div>{{ useCase.usecasetype | translateUseCaseType }}</div>
          <mat-icon *ngIf="!selectedUseCaseType; else showCloseBtn">add</mat-icon>
          <ng-template #showCloseBtn>
            <button
              mat-icon-button
              (click)="onUnselectUseCaseType($event)"
              gtm="onUnselectUseCaseType"
              gtmAction="Diagnostics Overlay"
              gtmCategory="Unselect use case type"
            >
              <mat-icon>close</mat-icon>
            </button>
          </ng-template>
        </div>
      </ng-container>
    </div>
  </div>

  <div class="full-width use-case-group-container flex flex-col gap-[16px] flex-1">
    <h2>
      {{ 'DIAGNOSTICS.USE_CASES.SELECT_USE_CASE_GROUP.TITLE' | translate }}
    </h2>

    <div
      *ngIf="!selectedUseCaseType; else showSelectedUseCaseGroups"
      class="empty-use-case-group-list flex flex-row justify-center items-start"
    >
      {{ 'DIAGNOSTICS.USE_CASES.SELECT_USE_CASE_GROUP.PLACEHOLDER_MESSAGE' | translate }}
    </div>

    <ng-template #showSelectedUseCaseGroups>
      <div class="flex flex-col gap-[8px]">
        <div
          *ngFor="let useCase of useCaseGroups$ | async"
          class="use-case-panel flex flex-row justify-between items-center"
          [class.selected]="selectedUseCaseGroup === useCase.texttableentry"
          [class.unselected]="
            selectedUseCaseGroup && selectedUseCaseGroup !== useCase.texttableentry
          "
          (click)="onSelectUseCaseGroup(useCase.texttableentry)"
          gtm="onSelectUseCaseGroup"
          gtmAction="Diagnostics Overlay"
          gtmCategory="Select use case group"
        >
          <div>{{ useCase.TI_texttableentry | translate }}</div>
          <mat-icon *ngIf="!selectedUseCaseGroup; else showCloseBtn">add</mat-icon>
          <ng-template #showCloseBtn>
            <button
              mat-icon-button
              (click)="onUnselectUseCaseGroup($event)"
              gtm="onUnselectUseCaseGroup"
              gtmAction="Diagnostics Overlay"
              gtmCategory="Unelect use case group"
            >
              <mat-icon>close</mat-icon>
            </button>
          </ng-template>
        </div>
      </div>
    </ng-template>
  </div>
</div>
